import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { HomeView } from "../views/HomeView";
import LoginPage from "../components/Login";
import { useAuth } from "../components/AuthContext";
import BookingPage from "../components/BookingPage";
import SchedulePage from "../components/SchedulePage";
import ClaimSuccess from "../components/ClaimSuccess";
import TermsAndConditions from "../components/TermsAndConditions";
import TermsAndConditionsConverse from "../components/TermsAndConditionsConverse";
import TermsAndConditionsOroh from "../components/TermsAndConditionsOroh";
import ServiceDashboard from "../components/ServiceDashboard/index";
import ClaimDetailPage from "../components/ServiceDashboard/ClaimDetailPage";
import ClaimTracker from "../components/ClaimTracker";
import ReviewPage from "../components/ReviewPage";

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
    const { user, isLoading } = useAuth();

    if (isLoading) {
        return <div className="text-white text-center mt-10">Loading...</div>;
    }

    return user ? children : <Navigate to="/login" replace />;
};

const AppRoutes = () => (
    <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/care-service" element={<BookingPage />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/cn-terms" element={<TermsAndConditionsConverse />} />
        <Route path="/or-terms" element={<TermsAndConditionsOroh />} />
        <Route path="/schedule/:bookingRef" element={<SchedulePage />} />
        <Route path="/claim-success" element={<ClaimSuccess />} />
        <Route path="/service-dashboard" element={<ServiceDashboard />} />
        <Route path="/service-dashboard/:claimId" element={<ClaimDetailPage />} />
        <Route path="/track" element={<ClaimTracker />} />
        <Route path="/track/:bookingRef" element={<ClaimTracker />} />
        <Route path="/review/:claimId" element={<ReviewPage />} />
        <Route
            path="/"
            element={
                <PrivateRoute>
                    <HomeView />
                </PrivateRoute>
            }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
);

export { AppRoutes };